import { mapGetters, mapActions } from 'vuex'

const moduleName = 'debtorsreceipts'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff'
    }),
    ...mapGetters(['licenceExpired'])
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'saveSnapshot', 'clearSnapshots']),
    ...mapActions('factorinvoice', { setFactorInvoiceReturnRoute: 'setReturnRoute' }),
    ...mapActions('debtoradjustments', { setDebtorAdjustmentsReturnRoute: 'setReturnRoute', setAdjustmentReadOnlyView: 'setReadOnlyView' }),
    ...mapActions('advancereceipt', { setAdvanceReadOnlyView: 'setReadOnlyView' }),
    ...mapActions('receiptpayment', { setReceiptPaymentReturnRoute: 'setReturnRoute', setReceiptReadOnlyView: 'setReadOnlyView' }),
    ...mapActions('printpreview', { setPrintPreviewReturnRoute: 'setReturnRoute', addEmailer: 'addEmailer', removeEmailer: 'removeEmailer' }),
    ...mapActions('printpreview', { addReportParameters: 'addParameters', removeReportParameters: 'removeParameters' })
  }
}
